'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowDownRightAndArrowUpLeft, iconArrowDownRightAndArrowUpLeftTag } from '@ni/nimble-components/dist/esm/icons/arrow-down-right-and-arrow-up-left';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowDownRightAndArrowUpLeft };
export { iconArrowDownRightAndArrowUpLeftTag };
export const NimbleIconArrowDownRightAndArrowUpLeft = wrap(IconArrowDownRightAndArrowUpLeft);